import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class VendorComplaintsService {
  url = environment.configURI;
  load;

  constructor(private http: HttpClient,private userFriendlyMsgs: UserFriendlyMsgs) {
    this.load = new BehaviorSubject('initial');
  }

  getVendorComplaints(Id){
    return this.http.get(this.url + '/vendorcomplaints/' + Id ).catch(this.userFriendlyMsgs.errorHandler);
  }

  getVendorComplaintDocs(complaint_id, vendor_id) {
    return this.http.get(this.url + '/vendorcomplaint/documents/' + vendor_id + '/' + complaint_id)
            .catch(this.userFriendlyMsgs.errorHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/vendor-complaints/vendor-complaints.service.ts